"use client";

import { useEffect, useRef, useState } from "react";
import { animate } from "animejs";
import { useTheme } from "next-themes";

const textOptions = [
    {
        text: "Find the ",
        highlight: "rarest items",
        suffix: " for your favorite games",
    },
    {
        text: "Trade your wares at the ",
        highlight: "black market",
        suffix: "",
    },
    {
        text: "Buy and sell with ",
        highlight: "no restrictions",
        suffix: "",
    },
];

export default function AnimatedText() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const textRef = useRef(null);
    const glowRef = useRef(null);

    useEffect(() => {
        const animateText = () => {
            if (!textRef.current) return;

            animate(textRef.current, {
                opacity: [1, 0],
                translateY: [0, -20],
                duration: 1000,
                ease: "outExpo",
                complete: () => {
                    setTimeout(() => {
                        setCurrentIndex((prev) => (prev + 1) % textOptions.length);
                    }, 100);
                },
            });
        };

        const interval = setInterval(animateText, 5000);

        animate(textRef.current, {
            opacity: [0, 1],
            translateY: [20, 0],
            duration: 1000,
            ease: "outBounce",
        });

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!textRef.current) return;

        animate(textRef.current, {
            opacity: [0, 1],
            translateY: [20, 0],
            duration: 1000,
            ease: "outBounce",
        });
    }, [currentIndex]);

    const currentText = textOptions[currentIndex];

    return (
        <h1 ref={textRef} className="text-8xl text-center opacity-0 text-foreground">
            {currentText.text}
            <span ref={glowRef} className="text-glow font-bold text-foreground">
                {currentText.highlight}
            </span>
            {currentText.suffix}
        </h1>
    );
}
